import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const Error = Loadable({
    loader: () => import('./Error'),
    render(loaded, props) {
      const Component = connect((state) => ({
        errorState: state.errorState,
        siteConfig: state.siteConfig
      }), {
        init
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path='/error'
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Error {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
